import { GameScene, IGameState } from '../../../State/Game/IGameState';
import { AdvertisementArea, IAdvertisementPayload } from '../../SDK/Advertisement';
import { track } from '../Track';
import { Random } from '../../Random';
import { AdGameArea } from '../DataSet/Ad';
import { isEndGame } from '../../../State/Level/LevelStateHelper';

export function trackAdvertisement(
    state: IGameState,
    payload?: IAdvertisementPayload
) {
    track('adID', Random.ID());
    if (payload) {
        track('adAdvertisementArea', payload.g_gameArea);
        switch (payload.g_gameArea) {
            case AdvertisementArea.PRIZE_WHEEL:
                track('adGameArea', AdGameArea.MAP);
                break;
            case AdvertisementArea.MISSION_SKIP:
                track('adGameArea', AdGameArea.SIDE_SCREEN);
                break;
            case AdvertisementArea.THREE_STAR_REWARD_MENU:
                track('adGameArea', AdGameArea.MAP);
                break;
            case AdvertisementArea.LEVEL_PLUS_FIVE_CARDS:
                if (isEndGame(state)) {
                    track('adGameArea', AdGameArea.FAIL_FLOW);
                } else {
                    track('adGameArea', AdGameArea.LEVEL);
                }
                if (state.levelState.levelNumber) {
                    track('adLevelNum', state.levelState.levelNumber);
                }
                track('adLevelType', "saga");
                track('adExtraCardsReceived', 5);
                break;
            case AdvertisementArea.LEVEL_COMPLETE:
                track('adGameArea', AdGameArea.LEVEL);
                if (state.levelState.levelNumber) {
                    track('adLevelNum', state.levelState.levelNumber);
                }
                track('adLevelType', "saga");
                break;
            case AdvertisementArea.NO_COINS_MENU:
                if (state.activeScene.result === GameScene.LEVEL) {
                    if (isEndGame(state)) {
                        track('adGameArea', AdGameArea.FAIL_FLOW);
                    } else {
                        track('adGameArea', AdGameArea.LEVEL);
                    }
                    if (state.levelState.levelNumber) {
                        track('adLevelNum', state.levelState.levelNumber);
                    }
                    track('adLevelType', "saga");
                } else {
                    track('adGameArea', AdGameArea.MAP);
                }
                track('adCoinsReceived', 100);
                break;
            default:
                break;
        }
        track('adRewardType', payload.g_rewardType);
    }
}
